const ACCESTOKENS = {
    listTokens: "Lista de tokens",
    newTokens: "Criar token",
    user: "Do utilizador",
    token: "Fichas",
    dateExpired: "F. Vencimento",
    company: "Companhia",
    acctions: "Ações",

    "delete": "Remover",
    edit: "Editar",
    accept: "Aceitar",
    cancel: "Cancelar",
    update: "Atualizar",

    titleAlert: "Remover token",
    messageAlert: "Deseja excluir o token?",

    searchUser: "Pesquisar usuário...",
    users: "Usuários",
    created: "Criada",
    Email: "E-mail",

    dateEspirated: "Data de expiração",
    phone: "Telefone",
    Role: "Função",
    createToken: "Criar token",
    new: "Novo",

    emptyTokens: "Não há tokens registrados.",
    listTokens: "Lista de tokens",
    dateEpiredCompany1: `Data de contratação da empresa**`,
    dateEpiredCompany2: `** expirou, você deve atualizá-lo.`,

    tokenIsUpdated: "O token foi atualizado",
    errorToUpdate: "Falha ao atualizar",
    CanNotUpdate: "Falha ao atualizar o token.",
    selectedUser: "Selecione um usuário",

    tooltip: {
        all: "Tudo",
        active: "Ativo",
        expired: "Atrasado"
    }


}

export default { ACCESTOKENS };